import { useState } from 'react';
import styled from 'styled-components';
import CenterModal from '../../components/modal/CenterModal';
import {
  MyPatternListProps,
  RegionProps,
} from '../../../interface/aiAnalyze/aiRecommend/type';
import {
  getInvestChips,
  getProfitChips,
  gradeInfo,
} from '../myAlgorithm/formatOptions';

interface DeleteModalProps {
  selectedItems: MyPatternListProps[];
  onClose: () => void;
  onConfirm: () => Promise<void>; // 삭제 API 실행 함수 (async)
  sigunguList: RegionProps[];
  emdList: RegionProps[];
}

const DeleteModal = ({
  selectedItems,
  onConfirm,
  sigunguList,
  emdList,
  onClose,
}: DeleteModalProps) => {
  const handleDelete = async () => {
    try {
      await onConfirm();
      onClose(); // 모달 닫기만 담당
    } catch (err) {
      console.error('삭제 실패:', err);
    }
  };

  return (
    <CenterModal onClose={onClose}>
      <Container>
        <Header>
          <ModalTitle>알고리즘을 삭제하시겠습니까?</ModalTitle>
          <ModalDesc>아래 알고리즘이 삭제됩니다.</ModalDesc>
        </Header>

        <Content>
          {selectedItems.map((item) => (
            <Item key={item.algorithm_idx}>
              <Grade $color={gradeInfo[item.grade]?.color}>
                {gradeInfo[item.grade]?.title}
              </Grade>
              <Title>{item.name || '나의 알고리즘'}</Title>
              <Options>
                {getInvestChips(item, sigunguList, emdList)
                  .map((chip) => chip.value)
                  .join(', ')}
                ,{' '}
                {getProfitChips(item)
                  .map((chip) => chip.value)
                  .join(', ')}
              </Options>
            </Item>
          ))}
        </Content>

        <ButtonBox>
          <Button onClick={onClose}>취소</Button>
          <Button $isDelete onClick={handleDelete}>
            삭제
          </Button>
        </ButtonBox>
      </Container>
    </CenterModal>
  );
};

export default DeleteModal;

const Container = styled.div`
  display: flex;
  padding: 24px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;

const ModalTitle = styled.div`
  color: #222;
  font-size: 18px;
  font-weight: 700;
  line-height: 145%; /* 26.1px */
  letter-spacing: -0.36px;
`;

const ModalDesc = styled.div`
  color: #616161;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 20.3px */
  letter-spacing: -0.28px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  align-self: stretch;
`;

const Item = styled.div`
  display: flex;
  padding: 8px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  border-bottom: 1px solid #e1e2e4;
`;

const Grade = styled.div<{ $color?: string }>`
  color: ${({ $color }) => $color};
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 17.4px */
  letter-spacing: -0.24px;
`;

const Title = styled.div`
  color: #222;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%; /* 20.3px */
  letter-spacing: -0.28px;
`;

const Options = styled.div`
  color: #616161;
  font-size: 12px;
  font-weight: 500;
  line-height: 145%; /* 17.4px */
  letter-spacing: -0.24px;

  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* 2줄까지만 보여줌 */
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ButtonBox = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

const Button = styled.button<{ $isDelete?: boolean }>`
  border: none;
  outline: none;
  background-color: transparent;

  display: flex;
  padding: 12px 42px;
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
  color: ${({ $isDelete }) => ($isDelete ? '#F45551' : '#616161')};
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%; /* 23.2px */
  letter-spacing: -0.32px;
`;
